// Mirrors client-communication's src/core/client-presence/client-presence.events.ts
export enum ClientPresenceEvents {
  PRESENCE = 'client:presence',
  CHECK = 'client:presence:check',
}

export interface ClientPresenceDto {
  userId: number;
  online: boolean;
}
